import React, { Component } from 'react';
import ExpandablePanel from '../../CommonComponents/ExpandablePanel';
import ActionStepsList from './ActionStepsList';
import { ACTION_STEPS_TOOLTIP_TEXT, SUGGESTIONS_TOOLTIP_TEXT } from './ActionStepsConstants';

class ActionStepsViewV2 extends Component {
  constructor() {
    super();
    this.state = {
      expanded: ADV.util.env('isPrintArea'),
    };
    this.setExpanded = this.setExpanded.bind(this);
    this.onActionStepsUlRef = this.onActionStepsUlRef.bind(this);
    this.onRequestAnimationFrame = this.onRequestAnimationFrame.bind(this);

    this.actionStepsUlSet = {};
  }

  componentDidMount() {
    const { getAdvisersInSameOrganization, clientId, isAdviserArea } = this.props;

    if (isAdviserArea) {
      getAdvisersInSameOrganization(clientId);
    }

    this.onRequestAnimationFrame();
  }

  componentWillUnmount() {
    this.cancelRaf = true;
  }

  onRequestAnimationFrame() {
    if (this.cancelRaf) {
      return;
    }
    window.setTimeout(this.onRequestAnimationFrame, 100);
  }

  onActionStepsUlRef(actionStepsUl, uuid) {
    this.actionStepsUlSet[uuid] = actionStepsUl;
  }

  setExpanded(expanded) {
    this.setState({
      expanded,
    });
  }

  render() {
    const {
      actionSteps,
      addActionStep,
      addSuggestion,
      clientId,
      DebtType,
      fpId,
      goalId,
      isAddingActionStep,
      isAddingSuggestion,
      isCurrentPlan,
      leftButtonText,
      leftTitle,
      onAddActionSteps,
      onAddSuggestions,
      onCancelAddingActionStep,
      onCancelAddingSuggestion,
      onChangeActionStepStatus,
      onDeleteActionStep,
      onDeleteSuggestion,
      onDoneAddingActionStep,
      onDoneAddingSuggestion,
      onResetActionSteps,
      onResetSuggestions,
      rightButtonText,
      rightTitle,
      setActionStepIcon,
      setActionStepText,
      setSuggestionIcon,
      setSuggestionText,
      suggestions,
      advisersInTheSameOrg,
      isLoadingAdvisersInTheSameOrg,
      currentClient,
      onDoneEditingActionStep,
      isAdviserArea,
      isConsumerArea,
      goal,
    } = this.props;

    if (isCurrentPlan) {
      return null;
    }
    return (
      <ExpandablePanel
        expanded={this.state.expanded}
        onExpandedChanged={this.setExpanded}
        hasExpand={actionSteps.length > 3 || suggestions.length > 3}
      >
        <div className="action-steps-split-panel">
          <div className="action-steps-split-panel-content">
            <ActionStepsList
              isAssignable
              onActionStepsUlRef={this.onActionStepsUlRef}
              title={leftTitle}
              tooltip={ACTION_STEPS_TOOLTIP_TEXT}
              emptyStateText="No action steps."
              buttonText={leftButtonText}
              onAdd={onAddActionSteps(clientId, fpId, goalId, actionSteps.length)}
              onReset={onResetActionSteps(clientId, fpId, goalId)}
              onDeleteItem={onDeleteActionStep(clientId, fpId, goalId)}
              onChangeStatus={onChangeActionStepStatus(clientId, fpId, goalId)}
              items={!this.state.expanded ? actionSteps.slice(0, 3) : actionSteps}
              isAdding={isAddingActionStep}
              addIcon={addActionStep.Icon}
              addText={addActionStep.Text}
              new={addActionStep}
              setIcon={setActionStepIcon(clientId, fpId, goalId)}
              setText={setActionStepText(clientId, fpId, goalId)}
              onDoneAdding={onDoneAddingActionStep(clientId, fpId, goalId, DebtType)}
              onDoneEditing={onDoneEditingActionStep(clientId, fpId, goalId)}
              onCancelAdding={onCancelAddingActionStep(clientId, fpId, goalId)}
              advisersInTheSameOrg={advisersInTheSameOrg}
              isLoadingAdvisersInTheSameOrg={isLoadingAdvisersInTheSameOrg}
              currentClient={currentClient}
              isAdviserArea={isAdviserArea}
              isConsumerArea={isConsumerArea}
              pulseCheckCategory={goal.PulseCheckCategory}
            />
          </div>
          <div className="action-steps-split-panel-content">
            <ActionStepsList
              isAssignable={false}
              hideReset
              onActionStepsUlRef={this.onActionStepsUlRef}
              title={rightTitle}
              tooltip={SUGGESTIONS_TOOLTIP_TEXT}
              emptyStateText="No suggestions."
              buttonText={rightButtonText}
              onAdd={onAddSuggestions(clientId, fpId, goalId)}
              onReset={onResetSuggestions(clientId, fpId, goalId)}
              onDeleteItem={onDeleteSuggestion(clientId, fpId, goalId)}
              onChangeStatus={() => {}}
              items={!this.state.expanded ? suggestions.slice(0, 3) : suggestions}
              isAdding={isAddingSuggestion}
              addIcon={addSuggestion.Icon}
              addText={addSuggestion.Text}
              new={addSuggestion}
              setIcon={setSuggestionIcon(clientId, fpId, goalId)}
              setText={setSuggestionText(clientId, fpId, goalId)}
              onDoneAdding={onDoneAddingSuggestion(clientId, fpId, goalId, DebtType)}
              onCancelAdding={onCancelAddingSuggestion(clientId, fpId, goalId)}
              isAdviserArea={isAdviserArea}
              isConsumerArea={isConsumerArea}
              pulseCheckCategory={goal.PulseCheckCategory}
            />
          </div>
        </div>
        <div className="action-steps-split-panel-vline hide-on-mobile-screens" />
      </ExpandablePanel>
    );
  }
}

export default ActionStepsViewV2;
